export default __webpack_public_path__ + "static/media/AktivGrotesk-Medium.941db246.ttf";